export default __webpack_public_path__ + "static/media/Almond-3S_about.744e388e.webp";